import React, {
  useState, memo, useCallback, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Collapse,
  Card,
  CardBody,
} from 'reactstrap';

import { ROOM_FACILITIES_TYPE, ROOM_TYPE } from 'constants/index';

import styles from './RadioConvenience.module.scss';

function RadioConvenience(props) {
  const {
    group,
    facilities,
    roomOfPlaceList,
    validation,
  } = props;

  const [collapse, setCollapse] = useState(false);

  const onChangeValueChecked = useCallback((e) => {
    validation.setValues((values) => ({
      ...values,
      [group]: {
        ...values[group],
        children: values[group].children.map((item) => {
          if (item.facility === facilities.facility) {
            return ({
              ...item,
              applyFor: e.target.value,
              rooms: e.target.value !== ROOM_FACILITIES_TYPE.ALL_ROOMS
                ? []
                : (roomOfPlaceList?.map((room) => room._id) || []),
            });
          }

          return item;
        }),
      },
    }));
  }, [validation, facilities, group, roomOfPlaceList]);

  const onClickCollapse = useCallback(() => {
    setCollapse((prev) => !prev);
  }, [setCollapse]);

  const onSelectRoom = useCallback((e) => {
    validation.setValues((values) => ({
      ...values,
      [group]: {
        ...values[group],
        children: values[group].children.map((item) => {
          if (item.facility === facilities.facility) {
            return ({
              ...item,
              rooms: e.target.checked
                ? [...item.rooms, e.target.value]
                : item.rooms.filter((room) => room !== e.target.value),
            });
          }

          return item;
        }),
      },
    }));
  }, [validation, facilities, group]);

  useEffect(() => {
    if (facilities.applyFor === ROOM_FACILITIES_TYPE.SOME_ROOMS) {
      setCollapse(true);
    } else {
      setCollapse(false);
    }
  }, [facilities.applyFor]);

  return (
    <div className={styles.Component}>
      <div className="Radio__Container">
        <div className="Radio__Header">
          <div className="Radio__Title">
            {facilities.vi}

            {facilities.isFeatured && (
              <div className="Radio__Highlight">Nổi bật</div>
            )}
          </div>

          {facilities.applyFor === ROOM_FACILITIES_TYPE.SOME_ROOMS && (
            <button
              className="Chevron__Button Chevron__ButtonMobile"
              type="button"
              onClick={onClickCollapse}
              aria-label="Toggle collapse"
            >
              <i
                className={`fas fa-angle-${collapse ? 'up' : 'down'} Chevron`}
              />
            </button>
          )}
        </div>

        <div className="Radio__Wrapper">
          <label className="Radio__Group">
            <Input
              name={facilities.facility}
              type="radio"
              className="Radio"
              value={ROOM_FACILITIES_TYPE.ALL_ROOMS}
              checked={facilities.applyFor === ROOM_FACILITIES_TYPE.ALL_ROOMS}
              onChange={onChangeValueChecked}
            />

            <span className="Radio__Name">
              Tất cả phòng
            </span>
          </label>

          <label className="Radio__Group">
            <Input
              name={facilities.facility}
              type="radio"
              className="Radio"
              checked={facilities.applyFor === ROOM_FACILITIES_TYPE.SOME_ROOMS}
              value={ROOM_FACILITIES_TYPE.SOME_ROOMS}
              onChange={onChangeValueChecked}
            />

            <span className="Radio__Name">
              Một số phòng
            </span>
          </label>

          <label className="Radio__Group">
            <Input
              name={facilities.facility}
              type="radio"
              className="Radio"
              checked={facilities.applyFor === ROOM_FACILITIES_TYPE.NO_ROOM}
              value={ROOM_FACILITIES_TYPE.NO_ROOM}
              onChange={onChangeValueChecked}
            />

            <span className="Radio__Name">
              Không có căn nào
            </span>
          </label>
        </div>

        <div className="Chevron__Wrapper Chevron__WrapperDesktop">
          {facilities.applyFor === ROOM_FACILITIES_TYPE.SOME_ROOMS && (
            <button
              className="Chevron__Button"
              type="button"
              onClick={onClickCollapse}
              aria-label="Toggle collapse"
            >
              <i
                className={`fas fa-angle-${collapse ? 'up' : 'down'} Chevron`}
              />
            </button>
          )}
        </div>
      </div>

      <Collapse
        isOpen={collapse}
      >
        <Card className="Collapse__Container">
          <CardBody className="Collapse__Content">
            <div className="Collapse__Inner">
              <div className="Collapse__Spacer" />
              <div className="Collapse__List">
                {roomOfPlaceList?.length > 0 && roomOfPlaceList.map((content) => (
                  <label className="Checkbox__Container" key={content._id}>
                    <Input
                      type="checkbox"
                      className="Checkbox"
                      value={content._id}
                      checked={facilities.rooms?.includes(content._id)}
                      onChange={onSelectRoom}
                    />

                    <span className="Checkbox__Name">{content.name || ROOM_TYPE[content.roomName]?.label}</span>
                  </label>
                ))}
              </div>
            </div>
          </CardBody>
        </Card>
      </Collapse>
    </div>
  );
}

RadioConvenience.propTypes = {
  group: PropTypes.string,
  facilities: PropTypes.instanceOf(Object),
  roomOfPlaceList: PropTypes.instanceOf(Array),
  validation: PropTypes.instanceOf(Object),
};

RadioConvenience.defaultProps = {
  group: '',
  facilities: {},
  roomOfPlaceList: [],
  validation: {},
};

export default memo(RadioConvenience);
